$(function() {

    let $body = $('body');
    let $window = $(window);

    /**
     *  Image Lazy Load
     */

    const observer = lozad(); // lazy loads elements with default selector as ".lozad"
    observer.observe();

    let $headerTop = $('#header .header-top');
    let $headerBottom = $('#header .header-bottom');
    let $headerMobile = $('#header-mobile');
    let $header = $('#header');

    /**
     *  Sticky Header
     */
    function stickyHeader() {
        let stickyPos = 0;
        let paddingToAdd = 0;
        const isHeaderTop = $headerTop.length;


        if($window.outerWidth() <= 569) {
            stickyPos = 0;
            paddingToAdd = $headerMobile.outerHeight();
        } else {
            if(isHeaderTop) {
                stickyPos = $headerTop.outerHeight();
                paddingToAdd = $headerBottom.outerHeight();
            }
        }

        if($window.scrollTop() >= stickyPos) {
            $header.addClass('header-stuck');
            if(isHeaderTop) {
                $header.css('padding-bottom',paddingToAdd);
            }
        } else {
            $header.removeClass('header-stuck');
            $header.css('padding-bottom',0);
        }
    }
    stickyHeader();
    $header.removeClass('header-stuck');
    $header.css('padding-bottom',0);


    // Back to top button
    let $backToTop = $('#back-to-top');

    function backToTop() {
        if($window.scrollTop() >= 200) {
            $backToTop.addClass('visible');
        } else {
            $backToTop.removeClass('visible');
        }
    }
    backToTop();

    $backToTop.click(function(){
        $('html,body').animate({
            scrollTop: 0
        });
    });


    // Scroll top functions
    let lastScrollTop = 0;

    function debounce(func, wait) {
        let timeout;
        return function(args) {
            let context = this;
            clearTimeout(timeout);
            timeout = setTimeout(func.apply(context, args),wait);
        };
    }

    function onScroll() {
        let currScrollTop = $window.scrollTop();
        let isScrollingDown = currScrollTop > lastScrollTop;
        let isHeaderVisible = currScrollTop < $header.outerHeight();

        $header[0].classList.toggle('scroll-up', !(isScrollingDown && !isHeaderVisible));
        lastScrollTop = currScrollTop;
    }

    $window.scroll('scroll', function(){
        stickyHeader();
        backToTop();
    });

    window.addEventListener('scroll',debounce(onScroll,16));


    /**
     *  Mobile Menu Trigger
     */

    function menuOpenClose() {
        if($body.hasClass('mobile-menu-open')) {
            $body.addClass('mobile-menu-closing');
            setTimeout(function(){
                $body.removeClass('mobile-menu-closing');
            },405);
        }
        $body.toggleClass('mobile-menu-open');
    }

    // Menu Trigger
    $('#mobile-menu-trigger').click(function(){
        menuOpenClose();
    });

    $('#mobile-menu-close-btn').click(function(){
        menuOpenClose();
    });

    $('#mobile-menu .drop').click(function(e){
        e.preventDefault();

        let $drop = $(this),
            $itemParent = $drop.closest('li'),
            $subnav = $itemParent.find('>.nav');

        if(!$subnav.length) {
            $subnav = $itemParent.find('.nav');
        }

        $subnav.slideToggle();
        $itemParent.toggleClass('drop-menu-active');
    });

    /**
     *  Tabs
     */

    $('.tabs-container').each(function(){
        let $container = $(this),
            $controller = $container.find('.tab-controller'),
            $tabs = $container.find('.tab');

        $controller.find('li').click(function(){
            let $item = $(this),
                index = $item.index();

            $item.addClass('active')
                .siblings().removeClass('active');

            $tabs.eq(index).addClass('active')
                .siblings().removeClass('active');
        });
    });


    /**
     *  Accordion
     */
    $('.accordion-item').each(function(){
        let $item = $(this),
            $title = $item.find('.accordion-item--title'),
            $content = $item.find('.accordion-item--content');

        if($item.hasClass('active')) {
            $content.show();
        }

        $title.click(function(){
            $item.toggleClass('active');
            $content.slideToggle();
        });
    });

    /**
     *   Slider
     */

    $('.slider-block').each(function(){
        let $block = $(this),
            $sliderEl = $block.find('.bxslider'),
            $controls = $block.find('.controls');

        const autoplay = $block.attr('data-autoplay') === "1";
        const speed = parseInt($block.attr('data-speed'),10) || 500;
        const pause = parseInt($block.attr('data-pause'),10) || 4000;
        const infiniteLoop = $block.attr('data-infinite') === "1";

        let $slider = $sliderEl.bxSlider({
            mode: 'horizontal', // vertical, horizontal, or fade
            ariaLive: true,
            ariaHidden: true,
            pager: ($(".bxslider li").length > 1) ? true: false,
            controls: ($(".bxslider li").length > 1) ? true: false,
            nextText: '',
            prevText: '',
            infiniteLoop: infiniteLoop,
            speed: speed,
            pause: pause,
            auto: autoplay,
            oneToOneTouch: true,
            hideControlOnEnd: false,
            preventDefaultSwipeX: true,
            preventDefaultSwipeY: false,
            touchEnabled:false
        });

        $sliderEl.find('a').click(function(e){
            e.preventDefault();

            window.location.href = $(this).attr('href');
        });

        $sliderEl.find('a').click(function(e){
            e.preventDefault();

            window.location.href = $(this).attr('href');
        });

        $controls.find('.slide-prev').click(function(e){
            e.preventDefault();

            $slider.goToPrevSlide();
        });

        $controls.find('.slide-next').click(function(e){
            e.preventDefault();

            $slider.goToNextSlide();
        });
    });
});